import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ButtonM, Content, Section, TextDiv } from "../../styles/Common";
import { styled } from "styled-components";
import bg from "../../styles/images/signup_bg.png";
import cat from "../../styles/images/cat.png";
import FindComponent from "../../components/login/FindComponent";
import OnePageLayout from "../../components/layout/OnePageLayout";

const FindPassword = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <OnePageLayout title="비밀번호 찾기">
      <Section>
        <Content>
          <TextDiv>
            <H3>비밀번호를 다음과 같은 방법으로 찾을 수 있어요!</H3>
          </TextDiv>
          <FindComponent />
        </Content>
        <DescTextDiv>
          <p>
            Mu Point 회원이 아니시라면?{" "}
            <NavLink className="col" to="/sign-up">
              회원가입 바로가기
            </NavLink>
          </p>
        </DescTextDiv>
      </Section>
    </OnePageLayout>
  );
};

export default FindPassword;

const DescTextDiv = styled(TextDiv)`
  padding-bottom: 3rem;
  letter-spacing: -0.42px;
  a {
    font-family: NanumSquareB;
  }
`;
const H3 = styled.h3`
  letter-spacing: -0.25px;
`;
